import { investments as base } from './base';
import { investments as AT } from './AT';
import { investments as CZ } from './CZ';
import { investments as SK } from './SK';
import { investments as RO } from './RO';
import { investments as HU } from './HU';
import { investments as HR } from './HR';

export const featureConfigMap = {
    base,
    AT,
    CZ,
    SK,
    RO,
    HU,
    HR,
};
